/* eslint-disable max-lines-per-function */
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { AISearchRepository, AISearchRepositoryElementsParams } from '../service/ai-search.repository.interface';
import { CheckSensitiveWordDTO } from './data-transfer/check-sensitive-word.dto';
import { GetQueryCountDTO } from './data-transfer/get-query-count.dto';
import { SetTechQueryDTO } from './data-transfer/set-tech-query.dto';
import { TransferQueryDTO } from './data-transfer/transfer-query.dto';
import { GetTechAreaDTO } from './data-transfer/get-tech-area.dto';
import { GetTechKeywordDTO } from './data-transfer/get-tech-keyword.dto';
import { GetTechSemanticDTO } from './data-transfer/get-tech-semantic.dto';
import { GetRelatedIpcDTO } from './data-transfer/get-related-ipc.dto';
import type { ApiSetTechQueryRequest } from '@/infrastructure/api-functions/interface/set-tech-query.interface';
import type { ApiTransferQueryRequest } from '@/infrastructure/api-functions/interface/transfer-query.interface';

@injectable()
export class AISearchRepositoryImpl implements AISearchRepository {
    constructor(
        @inject(CheckSensitiveWordDTO)
        private readonly _checkSensitiveWord: CheckSensitiveWordDTO,
        @inject(GetQueryCountDTO)
        private readonly _getQueryCount: GetQueryCountDTO,
        @inject(SetTechQueryDTO)
        private readonly _setTechQuery: SetTechQueryDTO,
        @inject(TransferQueryDTO)
        private readonly _transferQuery: TransferQueryDTO,

        @inject(GetTechAreaDTO)
        private readonly _getTechArea: GetTechAreaDTO,
        @inject(GetTechKeywordDTO)
        private readonly _getTechKeyword: GetTechKeywordDTO,
        @inject(GetTechSemanticDTO)
        private readonly _getTechSemantic: GetTechSemanticDTO,
        @inject(GetRelatedIpcDTO)
        private readonly _getRelatedIpc: GetRelatedIpcDTO,
    ) { }

    public checkSensitiveWord(value: string) {
        return this._checkSensitiveWord.fetch(value);
    }

    public getSummary(taskId: string, desc: string) {
        return this._getTechArea.fetch(taskId, desc);
    }

    public getElements(taskId: string, params: AISearchRepositoryElementsParams) {
        return this._getTechKeyword.fetch(taskId, params);
    }

    public getSemantic(value: string[]) {
        return this._getTechSemantic.fetch(value);
    }

    public getQueryCount(q: string) {
        return this._getQueryCount.fetch(q);
    }

    public setTechQuery(value: ApiSetTechQueryRequest) {
        return this._setTechQuery.fetch(value);
    }

    public transferQuery(value: ApiTransferQueryRequest) {
        return this._transferQuery.fetch(value);
    }

    public getRelatedIpc(value: string, type: string) {
        return this._getRelatedIpc.fetch(value, type);
    }
}
